import { Typography } from "@flash-tecnologia/hros-web-ui-v2";
import styled, { css } from "styled-components";

export interface NumberWrapperProps {
  size: number;
  variant: "active" | "default";
}

export const NumberWrapper = styled.div<NumberWrapperProps>`
  display: flex;
  justify-content: center;
  align-items: center;

  width: ${({ size }) => size}px;
  height: ${({ size }) => size}px;

  pointer-events: auto;

  background-color: ${({ theme, variant }) => {
    return {
      active: theme.colors.secondary[50],
      default: theme.colors.neutral[100],
    }[variant];
  }};
  padding: 1px 6px;
  border-radius: ${({ theme }) => theme.borders.radius.pill};

  border: ${({ theme, variant }) => {
    const borderColor = {
      active: theme.colors.secondary[50],
      default: theme.colors.neutral[90],
    }[variant];

    return css`
      ${theme.borders.width.xs2} solid ${borderColor};
    `;
  }};

  &:hover {
    border: ${({ theme, variant }) => {
      const borderColor = {
        active: theme.colors.secondary[50],
        default: theme.colors.secondary[70],
      }[variant];

      return css`
        ${theme.borders.width.xs2} solid ${borderColor};
      `;
    }};
  }

  &:focus-visible,
  &:active {
    box-shadow: 0 0 0 2px ${({ theme }) => theme.colors.secondary[90]};
  }
`;

export const NumberLabel = styled(Typography)`
  pointer-events: none;
`;
